<template>
  <ion-modal :is-open="isOpen" @didDismiss="close" :backdrop-dismiss="false" class="card-modal">
    <ion-card>
      <ion-card-content>
        <img v-if="imageUrl" :src="imageUrl" alt="Tutorial Image" class="tutorial-image" />
        <div v-html="formattedText" class="tutorial-text"></div>
        <ion-button @click="close" expand="block">Got It!</ion-button>
      </ion-card-content>
    </ion-card>
  </ion-modal>
</template>

<script setup>
import { computed } from 'vue';
import { IonModal, IonCard, IonCardHeader, IonCardTitle, IonCardContent, IonButton } from '@ionic/vue';
import MarkdownIt from 'markdown-it';

const props = defineProps({
  isOpen: {
    type: Boolean,
    required: true,
  },
  text: {
    type: String,
    default: '',
  },
  imageUrl: {
    type: String,
    default: null,
  },
});

const emit = defineEmits(['close']);

const md = new MarkdownIt();

const formattedText = computed(() => {
  return md.render(props.text);
});

const close = () => {
  emit('close');
};
</script>

<style scoped>
ion-card-title {
  font-size: 1.5em;
  font-weight: bold;
  margin-bottom: 20px;
}

.tutorial-text {
  text-align: left;
  margin-bottom: 20px;
}

.tutorial-text :deep(ul) {
  padding-left: 20px;
}

.tutorial-text :deep(li) {
  margin-bottom: 10px;
}

.tutorial-image {
  max-width: 100%;
  margin-bottom: 20px;
  border-radius: var(--hw-radius);
}
</style>
